export const userConstants = {
	REGISTER_REQUEST: 'USERS_REGISTER_REQUEST',
	REGISTER_SUCCESS: 'USERS_REGISTER_SUCCESS',
	REGISTER_FAILURE: 'USERS_REGISTER_FAILURE',

	LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
	LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
	LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',

	LOGOUT: 'USERS_LOGOUT',

	GETALL_REQUEST: 'USERS_GETALL_REQUEST',
	GETALL_SUCCESS: 'USERS_GETALL_SUCCESS',
	GETALL_FAILURE: 'USERS_GETALL_FAILURE',

	DELETE_REQUEST: 'USERS_DELETE_REQUEST',
	DELETE_SUCCESS: 'USERS_DELETE_SUCCESS',
	DELETE_FAILURE: 'USERS_DELETE_FAILURE',

	GET_USER_YAA_BY_ID_REQUEST: 'GET_USER_YAA_BY_ID_REQUEST',
	GET_USER_YAA_BY_ID_SUCCESS: 'GET_USER_YAA_BY_ID_SUCCESS',
    GET_USER_YAA_BY_ID_FAILURE: 'GET_USER_YAA_BY_ID_FAILURE',

    GET_USER_ACCEPT_REQUEST: 'GET_USER_ACCEPT_REQUEST',
    GET_USER_ACCEPT_SUCCESS: 'GET_USER_ACCEPT_SUCCESS',
    GET_USER_ACCEPT_FAILURE: 'GET_USER_ACCEPT_FAILURE',

    POST_USER_ACCEPT_REQUEST: 'POST_USER_ACCEPT_REQUEST',
    POST_USER_ACCEPT_SUCCESS: 'POST_USER_ACCEPT_SUCCESS',
    POST_USER_ACCEPT_FAILURE: 'POST_USER_ACCEPT_FAILURE',
}
